module.exports = __webpack_public_path__ + "static/media/599.7554 (6).f00c7eaa.pdf";